import React, { useEffect } from 'react'
import Modal from '../../Modal'
import Text from '../../Text'
import Youtube from '../../Youtube'
import Spacer from '../../Spacer'
import CategoryTitle from '../../CategoryTitle'
import Cta from '../../Cta'
import SimpleBlockContent from '../../SimpleBlockContent'
import styles from './styles.module.css'
import { $neutralGray80, $white } from '../../../styles/colors/primitives'

const cx = (...c) => c.filter(Boolean).join(' ')



function PictureAndText({ sideImage, category, theme = {}, title, text, reversed, ctas, containImage, imagePosition }) {
  const themeColorValue = theme.title.match(/\d+/) ? Number(theme.title.match(/\d+/)[0]) : null
  const textColor = themeColorValue && themeColorValue > 40 ? $white : $neutralGray80
  const dark = themeColorValue && themeColorValue < 50

  return (
    <div className={styles.wrapper} style={{ backgroundColor: theme.value }}>
      <div className={styles.contentWrapper}>
        <div className={styles.sideImageWrapper}>
          {/* task #67: the background url + position (prop-driven) go inline */}
          <div
            className={cx(styles.sideImage, containImage ? styles.sideImageContained : styles.sideImageCover)}
            style={{
              backgroundImage: sideImage?.src ? `url(${sideImage.src})` : undefined,
              backgroundPosition: imagePosition ? imagePosition : 'bottom',
            }}
          />
        </div>
        <div className={styles.textWrapper} style={{ gridRowStart: reversed ? 1 : 'auto' }}>
          {category && category.title && category.title.length > 0 && <CategoryTitle color={category.color?.value}>{category.title}</CategoryTitle>}
          {title && <div>
            <Spacer size={16} />
            <div style={{ color: textColor }}><Text type="H1">{title}</Text></div>
            </div>}
          <Spacer size={32} />
          <div style={{ color: textColor }}>
            {text && <SimpleBlockContent blocks={text} />}
          </div>
          <Spacer size={64} />
          {ctas && (
            <div className={styles.ctas}>
              {ctas.map((cta) => (
                <Cta {...cta} key={cta._key} dark={dark}/>
              ))}
            </div>
          )}
          <Spacer size={160} />
        </div>
      </div>
    </div>
  )
}

export default PictureAndText
